<template>
  <LeftTeaser :title="title" :subtitles="subtitles" :benefits="benefits" />
</template>

<script>
import LeftTeaser from '@/components/auth/left/LeftTeaser.vue'

export default {
  name: 'LeftRegisterInvited',
  components: {
    LeftTeaser,
  },
  props: {
    inviter: {
      type: Object,
      required: true,
      default: {},
    },
  },
  setup(props) {
    return {
      title: $t(':company invited you to join Worksome!', {
        company: props.inviter.company,
      }),
      subtitles: [
        $t(
          'With Worksome, you can review & accept contracts, submit bills, and get paid faster, so that you can',
        ),
      ],
      benefits: [
        $t('Start projects you love sooner'),
        $t('Have less paperwork'),
        $t('Focus on the actual work'),
      ],
    }
  },
}
</script>
